let $els = Array.from(document.querySelectorAll('[data-flkty]'))

let ARROW = `
<svg width="24" height="24" viewBox="0 0 24 24" class="flex-none" style="transform:rotate(45deg)">
  <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" transform="translate(6 6)">
    <path d="M11.625.373L.375 11.623"/>
    <polyline points="11.625 4.123 11.625 .373 7.875 .373"/>
  </g>
</svg>
`

if ($els.length) {
  import(/* webpackChunkName: 'flickity' */ 'flickity').then(Flickity => {
    $els.forEach($el => {
      let options = JSON.parse($el.getAttribute('data-flkty'))

      if ($el.hasAttribute('data-flkty-md') && window.innerWidth >= 768) {
        options = {
          ...options,
          ...JSON.parse($el.getAttribute('data-flkty-md'))
        }
      }

      let flkty = new Flickity($el, options)
      let selected = 0
      let counter = 1

      if ($el.classList.contains('js-flickity-opacity')) {
        let $cells = flkty.cells.map(c => c.element)
        $cells.forEach(($cell, i) => {
          if (i !== 0) {
            $cell.style.opacity = 0
          }
        })
        flkty.on('scroll', progress => {
          $cells.forEach(($cell, i) => {
            let inc = 1 / (flkty.cells.length - 1)
            let p = remap(progress, inc * (i - 1), inc * (i + 1))
            let opacity = clamp(normalize(p))
            $cell.style.opacity = opacity.toFixed(2)
          })
        })
      }

      let $nextButtonLabel = $el.getAttribute('data-next-button')
      let $nextButton
      if ($nextButtonLabel) {
        updateNextButton()
        flkty.on('change', updateNextButton)

        // eslint-disable-next-line
        function updateNextButton(index = 0) {
          if (!$nextButton) {
            $nextButton = document.createElement('button')
            $nextButton.className =
              'flickity-next-button w-1/2 absolute pin-b pin-r mr-gutter-half inline-flex py-0 pr-0 pl-4 items-center justify-end text-right font-secondary text-sm font-medium h-45'
            $nextButton.addEventListener('click', () => {
              flkty.select(flkty.selectedIndex + 1)
            })
            $nextButton.innerHTML = `<span class="mr-4"></span>${ARROW}`
            $el.appendChild($nextButton)
          }

          if (index === flkty.cells.length - 1) {
            $nextButton.style.opacity = 0
            $nextButton.disabled = true
            $nextButton.style.pointerEvents = 'none'
            return
          }
          $nextButton.style.opacity = 1
          $nextButton.disabled = false
          $nextButton.style.pointerEvents = 'auto'

          $nextButton.firstElementChild.innerHTML = `<span class="hidden sm:inline">Next - </span>${
            flkty.cells[index + 1].element.querySelector($nextButtonLabel)
              .textContent
          }`
        }
      }

      let $images = Array.from($el.querySelectorAll('[data-image]')).map($el =>
        document.getElementById($el.getAttribute('data-image'))
      )

      if ($images.length) {
        flkty.on('change', index => {
          selected = index

          counter++

          $images.forEach(($image, i) => {
            if (i === selected) {
              $image.style.transition = 'opacity 0.25s'
              $image.style.zIndex = counter
              $image.style.opacity = 1
            } else {
              $image.style.transition = 'opacity 0s 0.25s'
              $image.style.opacity = 0
            }
          })
        })
      }
    })
  })
}

function remap (num, inMin, inMax) {
  return ((num - inMin) * (1 - -1)) / (inMax - inMin) + -1
}

function clamp (x) {
  if (x < 0) return 0
  if (x > 1) return 1
  return x
}

function normalize (x) {
  if (x > 0) return 1 - x
  return 1 + x
}



// WEBPACK FOOTER //
// ./src/js/_flickity.js